import JoyButton from "./JoyButton";

export default function ErrorState({ onRetry }) {
  return (
    <div data-testid="error-state" className="flex flex-col items-center gap-4 text-center py-16 px-6">
      <img
        src="/joy.png"
        alt="Joy"
        className="w-24 h-24 rounded-full object-cover border-4 border-[#FFC0CB]"
      />
      <p className="font-bold text-[#4A3728] text-lg leading-snug">
        Ops! A Joy não conseguiu carregar essa parte agora.
      </p>
      <p className="text-[#8B7355] font-semibold">
        Tente novamente em alguns instantes. 🦊💕
      </p>
      {onRetry && (
        <JoyButton variant="pink" onClick={onRetry} data-testid="error-retry-btn">
          🔄 Tentar de novo
        </JoyButton>
      )}
    </div>
  );
}
